// Import Dependencies
import React, { FunctionComponent } from 'react';
import { CommonButton } from '../CommonButton';
// Import Local Styles
import styles from './modal.module.css';

interface ModalProps {
  headlineCopy: string;
  bodyCopy: string;
  isModalClosable: boolean;
  transparent: boolean;
  closeButtonCopy: string;
  onCloseCallBack?: any;
  modalType: string;
  setModalState: any;
  modalState: boolean;
}

export const Modal: FunctionComponent<ModalProps> = (props) => {
  const {
    headlineCopy,
    bodyCopy,
    isModalClosable,
    transparent,
    closeButtonCopy,
    onCloseCallBack,
    modalType,
    setModalState,
    modalState,
  } = props;

  function closeModal() {
    // if modal is closable, close it.
    if (isModalClosable) setModalState(false);
    if (onCloseCallBack) onCloseCallBack();
  }

  return (
    <>
      {modalState && (
        <div className={`${styles.blocker} ${transparent ? styles.transparent : ''}`} onClick={() => closeModal()}>
          <div className={`${styles.modal} ${styles[modalType]}`} onClick={(e) => e.stopPropagation()}>
            <div className={styles.wrapper}>
              <h3 className={styles.heading}>{headlineCopy}</h3>
              <p className={styles.prompt}>{bodyCopy}</p>
            </div>
            {isModalClosable && (
              <CommonButton arrow={false} modifier={styles.button} onClick={() => closeModal()}>
                {closeButtonCopy}
              </CommonButton>
            )}
          </div>
        </div>
      )}
    </>
  );
};
